import * as React from 'react';
import { Dialog, DialogFooter, IconButton, Label, PrimaryButton, Stack, TextField } from '@fluentui/react';
import { ITextArea, IWorkingArea } from '../../../../models';
import styles from './TextAreaDialog.module.scss';
import { isMobileOrTablet } from '../../../VisibilityControl/UserAgentControl';
import { LanguageContext } from '../../../../LanguageContext';

export interface ITextAreaDialogProps {
  currentTextArea: ITextArea;
  onSaveClicked(identifier: string, name: string, color: string): void;
  onChanged?: (name: string, color: string) => void;
  onDismiss?: () => void;
}

export interface ITextAreaDialogState {
  name: string;
  color: string;
  colors: string[];
}

export default class TextAreaDialog extends React.Component<ITextAreaDialogProps, ITextAreaDialogState> {
  static contextType = LanguageContext;
  context: React.ContextType<typeof LanguageContext>;

  private t(key: string): string {
    return this.context?.t ? this.context.t(key) : key;
  }

  constructor(props: ITextAreaDialogProps) {
    super(props);

    this.state = {
      name: props.currentTextArea.name ? props.currentTextArea.name + "" : "",
      color: props.currentTextArea.color ? props.currentTextArea.color + "" : "#4d6074",
      colors: ["#16a085", "#2ecc71", "#2980b9", "#3498db", "#9b59b6", "#e74c3c", "#f39c12", "#f1c40f", "#2c3e50", "#7f8c8d", "#bdc3c7", "#ecf0f1"] as string[]
    };
  }

  private renderActionButton() {
    return (
      <PrimaryButton
        style={{ width: '100%', marginBottom: 0, marginTop: -10 }}
        text={this.t('textAreaDialog.save')}
        disabled={this.state.name === "" || this.state.color === ""}
        onClick={() => {
          this.props.onSaveClicked(
            this.props.currentTextArea.identifier,
            this.state.name,
            this.state.color
          );
        }}
      />
    );
  }

  public render(): React.ReactElement<ITextAreaDialogProps> {
    const t = this.t.bind(this);

    return (
      <Dialog
        hidden={false}
        minWidth={300}
        onDismiss={this.props.onDismiss}
        modalProps={{ isBlocking: true }}
        dialogContentProps={{
          title: (
            <Stack
              horizontal
              horizontalAlign="space-between"
              verticalAlign="center"
              style={{ marginBottom: -10 }}
            >
              <Label style={{ fontSize: '16px' }}>{t('textAreaDialog.title')}</Label>
              <IconButton
                iconProps={{ iconName: 'Cancel' }}
                ariaLabel={t('textAreaDialog.close')}
                onClick={this.props.onDismiss}
                styles={{ root: { marginRight: -30, marginTop: 5 } }}
              />
            </Stack>
          )
        }}
      >
        {isMobileOrTablet() && (
          <div style={{
            position: 'sticky',
            top: 0,
            zIndex: 100,
            background: '#fff',
            paddingTop: 8,
            paddingBottom: 8
          }}>
            {this.renderActionButton()}
          </div>
        )}
        <TextField label={t('textAreaDialog.text')} value={this.state.name} required={true} onChange={(ev, newValue) => {
          this.setState({ name: newValue + "" }, () => {
            if (this.props.onChanged) {
              this.props.onChanged(this.state.name, this.state.color);
            }
          });
        }} />
        <Label>{t('textAreaDialog.fillColor')}</Label>
        <div className={styles.colorPickerContainer}>
          {this.state.colors.map((val, i, a) => {
            return <div className={styles.colorBox} style={{ backgroundColor: val, border: this.state.color == val ? "2px solid rgba(0,0,0, 0.25)" : "none" }} onClick={() => {
              this.setState({ color: val }, () => {
                if (this.props.onChanged) {
                  this.props.onChanged(this.state.name, this.state.color);
                }
              });
            }} />
          })}
        </div>
        {!isMobileOrTablet() &&
          <DialogFooter>
            {this.renderActionButton()}
          </DialogFooter>
        }
      </Dialog>
    );
  }
}